import React from "react";

export const Logo = ({ size = 32, showName = true }) => (
  <div className="flex items-center gap-2.5 select-none" data-testid="app-logo">
    <img src="/logo.png" alt="Ai Xtudio" width={size} height={size} className="shrink-0" style={{ width: size, height: size }} />
    {showName && <span className="font-heading font-semibold text-[17px] tracking-tight text-white">Ai Xtudio</span>}
  </div>
);
